
var Events = {
	registered : {},
	scrollEvent : {
		register: function(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

module.exports = Events;


// WEBPACK FOOTER //
// ./src/app/components/tc-ui/scroll-to/mixins/scroll-events.js